import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Moment, SocialSharing, GlobalContext } from 'commons';
import { orgId, clientTimeZone, baseUrl } from 'utils';

const Banner = ({ date, id, title, textMessage }) => {
  const {
    account: { timeZone },
    organization: { showNotificationsToMemberPortalSocialSharing, isPublic },
  } = useContext(GlobalContext);

  return (
    <div className="col-sm-12 date">
      <p>
        <Moment
          tz={timeZone || clientTimeZone}
          format="YYYY-MM-DD HH:mm:ss z"
          eb-test="ee_notificationDetail_text_datetime"
        >
          {date}
        </Moment>
      </p>
      {isPublic && showNotificationsToMemberPortalSocialSharing && (
        <SocialSharing
          url={`${baseUrl}/${orgId}/notif/${id}`}
          title={title}
          description={textMessage}
          eb-test="ee_notificationDetail_field_shareButtons"
        />
      )}
    </div>
  );
};
Banner.propTypes = {
  id: PropTypes.string.isRequired,
  date: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  textMessage: PropTypes.string.isRequired,
};

export default Banner;
